export default __webpack_public_path__ + "static/media/enter-phone.8fe60ac8.png";